<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent width="450">
        <v-card>
          <v-card-title class="headline">Course Delete</v-card-title>
          <v-card-text>
            <p>
              You have asked to delete
              <strong>{{ course ? course.name : "" }}</strong
              >.
            </p>
            <p>
              This action will permanently delete the course, but not any of the
              items within the course.
            </p>
            <p>
              Nor will it delete any courses of this type previously assigned to
              mentees.
            </p>
            <p>Select Delete if you understand and still want to procede.</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              id="js-delete-confirm"
              class="dangerous-action-btn"
              @click="deleteCourse()"
              >Delete</v-btn
            >
            <v-btn class="cancel-action-btn" @click="dialog = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-card class="course_details" outlined>
      <v-card-text>
        <p class="display-1 text--primary">
          {{ course ? course.name : "" }}
        </p>
        <p>{{ course ? course.description : "" }}</p>
        <div class="text--primary">
          <v-simple-table dense class="details-table">
            <tbody>
              <tr>
                <th class="text-left">assigned</th>
                <td id="js-number-assigned">{{ numberAssigned }}</td>
                <td id="js-names-assigned">{{ assignedToUsers.join(", ") }}</td>
              </tr>
              <tr>
                <th class="text-left">completed</th>
                <td id="js-number-completed">{{ numberCompleted }}</td>
                <td id="js-names-completed">{{ completedUsers.join(", ") }}</td>
              </tr>
              <tr>
                <th class="text-left">items</th>
                <td id="js-number-of-items">{{ numberOfItems }}</td>
                <td></td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex justify-end">
        <v-btn
          id="js-course-delete-button"
          v-if="showDelete"
          small
          class="dangerous-action-btn course-delete-button"
          @click="confirmDeleteCourse"
          >Delete</v-btn
        >
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    course: { type: Object, default: () => {} }
  },
  data: function() {
    return {
      deleteCourseId: 0,
      dialog: false
    }
  },
  created() {},
  computed: {
    showDelete() {
      // always show delete for now
      return true
    },
    numberOfItems() {
      return this.course ? this.course.learning_items.length : 0
    },
    assigned() {
      if (this.course) {
        let courses = this.$store.getters["courses/getCoursesByParentId"](
          this.course.id
        )

        courses = courses.filter(el => !el.hidden)

        return courses
      } else {
        return []
      }
    },
    numberAssigned() {
      return this.assigned.length
    },
    assignedToUsers() {
      let courses = this.assigned

      let users = this.getNames(courses)

      return users
    },
    completed() {
      let assignedCourses = this.assigned

      let completedAssignedCourses = assignedCourses.filter(el => {
        let allItemsCompleted = el.learning_items.every(itemId => {
          let item = this.$store.getters["learningItems/getLearningItemById"](
            itemId
          )
          return item.status
        })

        return allItemsCompleted && el.touched
      })

      return completedAssignedCourses
    },
    numberCompleted() {
      return this.completed.length
    },
    completedUsers() {
      return this.getNames(this.completed)
    }
  },
  methods: {
    getNames(courses) {
      let users = courses.map(el => el.user.first_name)

      const map = users.reduce(
        (acc, e) => acc.set(e, (acc.get(e) || 0) + 1),
        new Map()
      )

      let compiledUsers = []
      let entries = [...map.entries()]
      for (var i = 0; i < entries.length; i++) {
        if (entries[i][1] > 1) {
          compiledUsers.push(entries[i][0] + " (x" + entries[i][1] + ")")
        } else {
          compiledUsers.push(entries[i][0])
        }
      }

      return compiledUsers
    },
    confirmDeleteCourse() {
      this.deleteCourseId = this.course.id
      this.dialog = true
    },
    deleteCourse() {
      this.dialog = false

      this.$store.dispatch("courses/deleteCourse", this.deleteCourseId)

      this.$router.push({
        name: "coursesGridManager"
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";

.course_details {
  margin-bottom: 20px;
}
.details-table {
  max-width: 650px;
}
tbody {
  color: $dark-grey;
}
th {
  width: 30%;
  border-bottom: 1px solid $beige;
  text-transform: uppercase;
  font-style: italic;
}

td {
  border-bottom: 1px solid $beige !important;
}

tr:hover {
  background: $beige !important;
}

.course-delete-button {
  margin: 10px 40px 5px 40px;
}
</style>
